import React from "react";
import styled from "styled-components";

interface Props {
  isConnected: boolean;
  className?: string;
}

const StyledConnectionIndicator = styled.div<Pick<Props, "isConnected">>`
  width: 0.5em;
  height: 0.5em;
  display: inline-block;
  background: ${({ isConnected }) =>
    isConnected ? "mediumseagreen" : "crimson"};
`;

const ConnectionIndicator = ({ isConnected, className }: Props) => {
  return (
    <StyledConnectionIndicator
      className={className}
      isConnected={isConnected}
    ></StyledConnectionIndicator>
  );
};

export default ConnectionIndicator;
